<div class="user-status">
  <div>{{ user.status | userStatus }}</div>
  <small *ngIf="user.status === userStatuses.invitationSent || user.status === userStatuses.passwordReset">{{
    user.resetPasswordSentAt | date: 'M/d/yyyy'
  }}</small>
</div>
